import { publicationProxy } from '../common/apiProxy';
import {costCenterProxy} from '../common/proxies/negServiceProxy';
import actionTypes from './upcomingPublication.actionTypes';
import { getPaginationInfo, getUpcomingPublicationFiltersQueryString, 
    getUpcomingPublicationSearchText, getUpcomingPublicationListSortConfig } from './upcomingPublication.selectors';
import { extractTokenForSearch, normalizeSortConfig } from '../common/sponsorships/list/sponsorshipHelper';
import { getQueryStringWithUpcomingPublicationStatus, getQueryStringWithDealStatus } from '../common/sponsorships/filters/filterHelper';
import filterId from '../common/sponsorships/filters/filter_ids';


let timeoutId = null;

function receiveUpcomingPublications(responseContent, filterQueryString = null, searchText = null, 
                                sortField = null, sortDirection = null) {
    const action = {
        type: actionTypes.RECEIVE_UPCOMING_PUBLICATIONS_SUCCESS,
        ...responseContent,
        filterQueryString,
        searchText,
        sortField,
        sortDirection,
        receivedAt: Date.now()
    };
    return action;
}

async function requestUpcomingPublications(dispatch, options, shouldDelay = false, token = null, tenantId = null) {
    if(shouldDelay) {
        clearTimeout(timeoutId);
    }

    const waitMilliseconds = shouldDelay ? 2000: 0;
    timeoutId = setTimeout(() => {
        dispatch({type: actionTypes.REQUEST_UPCOMING_PUBLICATIONS, ...options});
        publicationProxy.getPublications(options, token, tenantId, true).then(responseContent => {
            let action = receiveUpcomingPublications(responseContent, 
                options.filterQueryString, options.searchText,
                options.sortField, options.sortDirection);
            dispatch(action);
        });
    }, waitMilliseconds);
}

export function getUpcomingPublications({ pageSize, pageNumber, sortByField, sortByDirection, filterQueryString }, token, tenantId ) {
    return async (dispatch, getState) => {

        let sortConfig = {};
        if(sortByField && sortByDirection) {
            sortConfig = normalizeSortConfig({field: sortByField, dir: sortByDirection});
        }
        const state = getState();
        filterQueryString = completeFilterQueryString(state, filterQueryString);
        await requestUpcomingPublications(dispatch, {
            pageSize,
            pageNumber,
            filterQueryString,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function exportUpcomingPublications(exportFields, token, tenantId) {
    return async(dispatch, getState) => {

        const state = getState();
        const options = {
            exportFields,
            filterQueryString: completeFilterQueryString(state),
            searchTexT: getUpcomingPublicationSearchText(state),
            ...getUpcomingPublicationListSortConfig(state)
        };
        publicationProxy.exportPublications(options, token, tenantId);

    };
}

export function changeUpcomingPublicationListPage({skip, take}, token, tenantId) {
    return async(dispatch, getState) => {
        const pageSize = take;
        const pageNumber = (skip / pageSize) + 1;

        const state = getState();
        const filterQueryString = completeFilterQueryString(state);
        const searchText = getUpcomingPublicationSearchText(state);
        const sortConfig = getUpcomingPublicationListSortConfig(state);

        await requestUpcomingPublications(dispatch, { 
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function changeUpcomingPublicationListFilter(filterQueryString, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);

        const pageNumber = 1; 
        const searchText = getUpcomingPublicationSearchText(state);
        const sortConfig = getUpcomingPublicationListSortConfig(state);
        const newQueryString = completeFilterQueryString(state, filterQueryString);

        await requestUpcomingPublications(dispatch, { 
            pageSize, 
            pageNumber, 
            filterQueryString: newQueryString, 
            searchText,
            ...sortConfig
        }, true, token, tenantId);

    };
}

export function changeUpcomingPublicationListOrder({field, dir}, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);
        const pageNumber = 1;
        const filterQueryString = completeFilterQueryString(state);
        const searchText = getUpcomingPublicationSearchText(state);

        const sortConfig = normalizeSortConfig({field, dir});

        await requestUpcomingPublications(dispatch, {
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText,
            ...sortConfig
        }, false, token, tenantId);
    };
}

export function searchUpcomingPublications(searchText, token, tenantId) {
    return async(dispatch, getState) => {
        const state = getState();
        const { pageSize } = getPaginationInfo(state);
        const pageNumber = 1;
        const filterQueryString = completeFilterQueryString(state);
        const sortConfig = getUpcomingPublicationListSortConfig(state);

        const searchToken = extractTokenForSearch(searchText);

        await requestUpcomingPublications(dispatch, {
            pageSize, 
            pageNumber, 
            filterQueryString, 
            searchText: searchToken,
            ...sortConfig
        }, false, token, tenantId);
    };
}


function receiveUpcomingPublicationFilters(responseContent) {
    const action = {
        type: actionTypes.RECEIVE_UPCOMING_PUBLICATION_FILTERS_SUCCESS,
        ...responseContent.data,
        receivedAt: Date.now()
    };
    return action;
}

export function getUpcomingPublicationFilters(status_ids, token, tenantId){
    return async (dispatch) => {
        dispatch({type: actionTypes.REQUEST_UPCOMING_PUBLICATION_FILTERS});
        const responseContent = await publicationProxy.getPublicationFilters(status_ids, token, tenantId);
        const budgetsFilter = tenantId ? await costCenterProxy.getBudgetsByTenantId(token, tenantId) : ['No budgets'];
        responseContent['data']['budgets'] = budgetsFilter;

        let action = receiveUpcomingPublicationFilters(responseContent);
        dispatch(action);
    };
}

function completeFilterQueryString(state, existingQueryString = null) {
    let result = existingQueryString === null ? getUpcomingPublicationFiltersQueryString(state): existingQueryString;

    if(!result) {
        result = getQueryStringWithUpcomingPublicationStatus();
        result += '&' + getQueryStringWithDealStatus();
        return result;
    } 
    if(!result.includes(filterId.STATUS)) {
        result += '&' + getQueryStringWithUpcomingPublicationStatus();
    }
    if(!result.includes(filterId.DEAL_STATUS)) {
        result += '&' + getQueryStringWithDealStatus();
    }

    return result;
}